import { LOCATION_FORM_ADD_CHANGE, RESET_LOCATION_FORM, RESET_LOCATION_FIELD} from  '../redux/reducers/locationForm'

export const locationFormChange = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: LOCATION_FORM_ADD_CHANGE, ...data})
    }
};


export const locationFormReset = () => {
    return (dispatch: any) => {
        return dispatch({type: RESET_LOCATION_FORM})
    }
};

export const locationFormFieldReset = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: RESET_LOCATION_FIELD, ...data})
    }
};
